<template>
  <v-dialog :model-value="isEditApplicationDialogActived" max-width="980px" persistent scrollable>
    <v-card class="dialog-card">
      <v-card-title class="dialog-title">
        <span>{{ getDialogTitle() }}</span>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid" validate-on="lazy">
          <section class="form-section">
            <h2>Datos de aplicacion</h2>
            <v-row dense>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="editedItem.applicationNumber"
                  label="Aplicacion numero"
                  type="number"
                  min="0"
                  variant="outlined"
                  density="comfortable"
                  :rules="[rules.requiredFieldRule, rules.min0]"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  v-model="editedItem.applicationType"
                  label="Tipo de Aplicacion"
                  item-title="name"
                  return-object
                  variant="outlined"
                  density="comfortable"
                  :rules="[rules.requiredFieldRule]"
                  :items="getAgrochemicalApplicationTypes"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="editedItem.haAmount"
                  label="Cantidad de Hectareas"
                  type="number"
                  min="0"
                  variant="outlined"
                  density="comfortable"
                  :rules="[rules.requiredFieldRule, rules.min0]"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="editedItem.applicationDate"
                  label="Fecha de Aplicacion"
                  type="date"
                  variant="outlined"
                  density="comfortable"
                  :rules="[rules.requiredFieldRule]"
                />
              </v-col>
            </v-row>
          </section>

          <section class="form-section">
            <h2>Selecciona un lote</h2>
            <v-alert v-if="!islandBatchSelected" class="mb-3" type="error" variant="tonal">
              Debe seleccionar un lote.
            </v-alert>
            <land-batch-selector v-model="editedItem.landBatch" />
          </section>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" variant="text" @click="close">Cancelar</v-btn>
        <v-btn v-if="canUpdate" color="primary" @click="save">Guardar Cambios</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex'
import LandBatchSelector from '../Common/LandBatchSelector'

export default {
  name: 'EditAgrochemicalForm',
  components: {
    LandBatchSelector
  },
  data: () => ({
    valid: true,
    rules: {
      requiredFieldRule: v => !!v || 'Campo requerido.',
      min0: v => (v > 0) || 'Debe ingresar un valor mayor que 0'
    },
    editedItem: {},
    islandBatchSelected: true
  }),
  computed: {
    ...mapGetters('agrochemicalModule', ['isEditApplicationDialogActived', 'getAgrochemicals']),
    ...mapGetters('typesModule', ['getAgrochemicalApplicationTypes']),
    ...mapGetters('authModule', ['hasPermission']),
    canUpdate () { return this.hasPermission('agrochemicals.applications.update') }
  },
  created () {
    this.$store.dispatch('typesModule/getAgrochemicalApplicationTypes')
  },

  watch: {
    'isEditApplicationDialogActived': function (val) {
      if (val) {
        this.editedItem = Object.assign({}, this.$store.getters['agrochemicalModule/getSelectedApplicationItem'])
        this.valid = true
        this.$nextTick(() => this.$refs.form?.resetValidation())
      }
    }
  },

  methods: {
    getDialogTitle () {
      return `Editando Aplicacion: ${this.editedItem.applicationNumber || ''}`
    },

    close () {
      let defaultItem = this.$store.getters['agrochemicalModule/getDefaultApplicationItem']
      this.editedItem = Object.assign({}, defaultItem)
      this.valid = true
      if (this.$refs.form) {
        this.$refs.form.resetValidation()
      }
      this.$store.dispatch('agrochemicalModule/setSelectedApplicationItem', defaultItem)
      this.$store.dispatch('agrochemicalModule/setEditApplicationDialogActived', false)
    },

    async save () {
      if (!this.canUpdate) return
      if (this.editedItem.landBatch && Number(this.editedItem.landBatch.id) > 0) {
        this.islandBatchSelected = true
        const validation = await this.$refs.form.validate()
        if (validation.valid) {
          try {
            await this.$store.dispatch('agrochemicalModule/saveAgroApplication', this.editedItem)
            this.close()
          } catch (e) {
            console.log('Error saving agrochemical application.', e)
          }
        }
      } else {
        this.islandBatchSelected = false
      }
    }
  }
}
</script>
